var map = {
	"./accessibility_compliance.png": 8278,
	"./competitive_analysis.png": 8106,
	"./design_reviews.png": 4848,
	"./ideation.png": 7667,
	"./interaction_design.png": 1129,
	"./personas.png": 4399,
	"./research_synthesis.png": 2900,
	"./sitemaps_ia.png": 1863,
	"./summarize_meetings.png": 972,
	"./summarize_notes.png": 8531,
	"./summarize_transcripts.png": 1973,
	"./user_flows.png": 6783,
	"./ux_roadmap.png": 1214,
	"./wireframes.png": 8361,
	"./workshops.png": 8392
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1947;